module.exports = __webpack_public_path__ + "static/portfolio-16-fb295c35cc618a19b1f0aae13c5f7494.jpg";